import React, { FC } from 'react';

const Logs: FC = () => {
  return <>Logs</>;
};
export default Logs;
